module.exports = __webpack_public_path__ + "img/i-translation.d14852e0.png";